class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}